import React from "react";
import { motion } from "framer-motion";
import businessImageBanner from "../../../../../images/web/business-banner-img.jpg";
import Button from "../../../components/ui/Button";
import { FaArrowRight } from "react-icons/fa6";
import { CONSULTATION_URL } from "../../../../../routes/data";

const Banner: React.FC = () => {

  return (
    <>
      <section className="relative pt-8 pb-16 lg:pt-12 lg:pb-32 overflow-hidden">
        {/* Decorative background element */}
        <div className="absolute top-0 right-0 w-1/2 h-full bg-blue-50/30 -z-10 skew-x-12 transform origin-top-right" />

        <div className="mx-auto max-w-7xl px-6 lg:px-8 relative z-10">
          <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
            {/* Left Content */}
            <div className="max-w-2xl lg:max-w-none text-center lg:text-left mx-auto lg:mx-0">
              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-h1 font-bold font-spartan text-black-1a mb-8"
              >
                Maximize{" "}
                <span className="text-blue-00 italic mx-2">Visa Approval 🛂</span>{" "}
                with AI Risk Checker
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="mt-8 text-xl leading-8 text-dark-6b font-inter font-medium"
              >
                Manage all visa applications from one centralized dashboard.
                Reduce risks, improve efficiency, and scale your global
                workforce with ease.
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="mt-10 flex items-center justify-center lg:justify-start gap-x-6"
              >
                <Button
                  label="Request A Free Demo"
                  onClick={() => window.open(CONSULTATION_URL, "_blank")}
                  variant="primary"
                  size="large"
                  endIcon={<FaArrowRight />}
                />
              </motion.div>
            </div>

            {/* Right Visual */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="mt-16 lg:mt-0 relative"
            >
              <div className="relative rounded-[2.5rem] overflow-hidden border-12 border-white bg-white shadow-2xl h-[500px] lg:h-[600px] group">
                <img
                  src={businessImageBanner}
                  alt="Business Visa Management"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />

                {/* Floating Badge / UI Mock */}
                <div className="absolute top-8 left-8 bg-white/95 backdrop-blur-md p-5 rounded-2xl shadow-xl border border-gray-100 flex flex-col items-start min-w-[200px] animate-bounce-slow">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="h-10 w-10 rounded-full bg-green-100 flex items-center justify-center text-green-600 text-xl">
                      🛡️
                    </div>
                    <div>
                      <p className="text-[10px] text-gray-500 font-bold uppercase tracking-wider">
                        Risk Level
                      </p>
                      <p className="text-sm font-bold text-green-600">
                        Secure (98%)
                      </p>
                    </div>
                  </div>
                  <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden">
                    <motion.div
                      initial={{ width: 0 }}
                      animate={{ width: "98%" }}
                      transition={{ duration: 1.5, delay: 1 }}
                      className="h-full bg-green-500"
                    />
                  </div>
                </div>

                <div className="absolute bottom-8 right-8 bg-blue-00 p-5 rounded-2xl shadow-xl text-white flex flex-col items-start min-w-[180px]">
                  <p className="text-[10px] opacity-80 font-bold uppercase tracking-wider mb-1">
                    Active Cases
                  </p>
                  <p className="text-3xl font-bold">1,248</p>
                  <div className="mt-2 text-[11px] bg-white/20 px-2 py-0.5 rounded-full">
                    +12% this month
                  </div>
                </div>
              </div>

              {/* Decorative elements */}
              <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] border border-blue-100 rounded-full opacity-50" />
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
